'use strict';

function LoanApplicationIncomeMonthly() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._$classes = {
    form: '.js--monthly-income-form',
    nextBtn: '.js--next',
    prevBtn: '.js--previous',
    inputCustomMonthDay: '.js--month-select',
    selectGroup: '.js--monthly-radio-group'
  };

  this._fieldsInteractedWith = [];
  this._submissionFlag = false;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._$node = $(this.node);
    this._$form = this._$node.find(this._$classes.form);
    this._$nextBtn = this._$node.find(this._$classes.nextBtn);
    this._$prevBtn = this._$node.find(this._$classes.prevBtn);
    this._$inputGroup = this._$node.find(this._$classes.selectGroup);
    this._$inputCustomMonthDate = this._$node.find(this._$classes.inputCustomMonthDay);

    this._pushPageAnalytics();
    this._setupEventHandlers();
    this._setupComputedVariables();
    this._setupForm();
    this._removeProgressLoader();
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._setupForm = function () {
    for (var i = 1; i < 30; i++) {
      var isLast = i === 29;
      this._$inputCustomMonthDate.mogo().addOption(i, i, false, isLast);
    }
  };

  this._setupComputedVariables = function () {
    var _this = this;

    // Month date dropdown
    this.presenter.addComputedVariable('day_of_month', ['money._loanApplicationIncome.first_pay_date'], function (dateString) {
      var firstPayDate = void 0;
      if (dateString) {
        firstPayDate = moment(dateString).format('D');
        return firstPayDate;
      }
    });

    // Month date dropdown
    this.presenter.addComputedVariable('last_day', ['money._loanApplicationIncome.last_day_of_month'], function (val) {
      // BE has NULL values sometimes!
      if (_this.presenter.getModelProperty('money._loanApplicationIncome.second_pay_date')) {
        return false;
      }
      return val;
    });
  };

  this._setupEventHandlers = function () {
    var _this2 = this;

    this._$form.on('submit', this._onValidateForm.bind(this));

    this._$form.on('change', this._onOptionSelected.bind(this));

    this._$prevBtn.on('click', function (e) {
      if (e) e.preventDefault();
      _this2._history.goToUrl(_this2.paths.loans.application_flow_income);
    });

    this._onFieldInteraction(this._$inputGroup);
    this._onFieldInteraction($('.js--month-select')); // Within Boolean group so use selector instead
  };

  this._onOptionSelected = function () {
    // On change boolean group is selected
    this._$inputGroup.mogo().hideErrorLabel();
    this._$inputGroup.mogo().hideError();

    // If dropdown selected
    if (this._$inputCustomMonthDate.mogo().val()) {
      this._$inputCustomMonthDate.mogo().hideError();
      this._$inputCustomMonthDate.mogo().hideErrorLabel();
    }
  };

  this._onValidateForm = function (e) {
    if (e) e.preventDefault();
    var data = this._$form.serializeFormToObj();
    var lastDayOfMonthBoolean = data.last_day_of_month;
    var dayOfMonthVal = data.day_of_month;

    // No radio selected
    if (!lastDayOfMonthBoolean) {
      this._$inputGroup.mogo().showErrorLabel();
      this._pushFormErrorAnalytics('last_day_of_month'); // Not using BE to validate
      // not last day of month and no value selected on dropdown
      return;
    }
    if (lastDayOfMonthBoolean === 'false' && !dayOfMonthVal) {
      this._$inputCustomMonthDate.mogo().showErrorLabel();
      this._pushFormErrorAnalytics('day_of_month'); // Not using BE to validate
      return;
    }
    // Save Monthly Pay Frequency
    $.each(this._$nextBtn, function (index, value) {
      value.mogo().setDisabledLoadState();
    });
    this._loanApplications[0].saveMonthlyPayFrequency(lastDayOfMonthBoolean, dayOfMonthVal);
    this._loanApplications[0].submitIncome({
      success: this._onSubmitIncomeSuccess.bind(this),
      failure: this._onSubmitIncomeFailure.bind(this)
    });
  };

  this._onSubmitIncomeSuccess = function () {
    this._pushFormSubmitAnalytics();
    this._setSubmissionFlag(true);
    // If it's edit mode, go to the next page then create,
    // Note: _loanAppGoToNextStep resets editMode to false;
    if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
      $('#LoanApplicationTray').mogo()._loanAppGoToNextStep();

      $('#Notification').mogo().create({
        type: 'success',
        msg: 'Your loan payment dates have been adjusted based on your new pay frequency. Make sure you review your application carefully before submitting it.'
      });
    } else {
      $('#LoanApplicationTray').mogo()._loanAppGoToNextStep();
    }
  };

  this._onSubmitIncomeFailure = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      this._$nextBtn.mogo().removeDisabledLoadState();

      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });

      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.msg));
      });
    }
  };

  this.destroy = function () {
    if (this._submissionFlag === false) {
      this._pushAbandonmentData();
    }
    this._super();
  };

  // Analytics
  this._setSubmissionFlag = function (boolean) {
    if (boolean !== null) this._submissionFlag = boolean;
  };

  this._onFieldInteraction = function (domElement) {
    var elemName = domElement.attr('name');

    if (!elemName) return console.warn('Cannot find name in domElement, please pass through correct domElement');

    var elem = $('[name=\'' + elemName + '\']', this.node);
    var fieldComponent = $(elem).mogo();

    // From UI Schema Validation
    if (fieldComponent instanceof Select) {
      $(fieldComponent.containerDiv).on('enter', setInteractionField.bind(this, elem));
      $(fieldComponent.containerDiv).on('leave', setInteractionField.bind(this, elem));
      $(elem).on('focus', setInteractionField.bind(this, elem));
      $(elem).on('blur', setInteractionField.bind(this, elem));
    } else if (fieldComponent instanceof BooleanGroup) {
      for (var j = 0; j < fieldComponent.groupElements.length; j++) {
        $(fieldComponent.groupElements[j]).on('focus', setInteractionField.bind(this, elem));
        $(fieldComponent.groupElements[j]).on('blur', setInteractionField.bind(this, elem));
      }
    }

    function setInteractionField(elem, event) {
      $(elem)[0].dataset.interacted = true;
    }
  };

  this._pushPageAnalytics = function () {
    var url = window.location.pathname + (this.presenter.getModelProperty('money._loanApplicationEdit') === true ? '-edit' : '');

    this.analytics.forcePushEvent('virtual-page-view', {
      Page: [url]
    });
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._findInteractedFields = function () {
    var fields = this._$form[0].elements;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        this._fieldsInteractedWith.push(fields[i].name);
        fields[i].dataset.interacted = 'false'; // reset fields
      }
      // Boolean Group
      if (fields[i].localName === 'fieldset' && fields[i].parentElement.dataset.interacted === 'true') {
        this._fieldsInteractedWith.push($(fields[i].parentElement).attr('name'));
        fields[i].parentElement.dataset.interacted = 'false'; // reset fields
      }
    }
  };

  this._resetInteractedFields = function () {
    var fields = this._$form[0].elements;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        fields[i].dataset.interacted = 'false'; // reset fields
      }
      // Boolean Group
      if (fields[i].localName === 'fieldset' && fields[i].parentElement.dataset.interacted === 'true') {
        fields[i].parentElement.dataset.interacted = 'false'; // reset fields
      }
    }

    this._fieldsInteractedWith = [];
  };

  this._pushAbandonmentData = function () {
    this._findInteractedFields();

    if (this._fieldsInteractedWith.length) {
      this.analytics.forcePushEvent('form-abandoned', {
        FormAbandoned: [this._fieldsInteractedWith.join(', ')]
      });
    }
  };

  this._pushFormErrorAnalytics = function (formId) {
    var formErrorId = null;
    if (formId) formErrorId = formId;

    this.analytics.forcePushEvent('form-errors', {
      FormErrors: [formErrorId]
    });
  };

  this._pushFormSubmitAnalytics = function () {
    var formAnalyticsID = '';
    if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
      formAnalyticsID = 'Money-Form Submission-Monthly Pay Day Edit-null-Form';
    } else {
      formAnalyticsID = 'Money-Form Submission-Monthly Pay Day-null-Form';
    }
    this.analytics.forcePushEvent('form-submit', {
      FormID: [formAnalyticsID]
    });
  };
}